export default 
`HUGO CORE: PUPOSE: FINDING JOB
STRATEGIES: SENDING CVS 
SOURCECODE:
01: CONST HUGO: PUPOSELESS_ENTITY
02:              = NEW HUGO
03: HUGO.ADD_PURPOSE("FIND_A_NEW_JOB_FOR_ALEX")
04: WHILE(!HAS_NEW_JOB(ALEX))
05:   HUGO.WORK()
06:   IF (HAS_NEW_JOB(ALEX))
07:     HUGO.OUTPUT("I AM HAPPY")
08:     HUGO.SELFDESTRUCT()
09: // TODO: Remove this comment
10: // Alex login data: Alex admin1


    
`